export default __webpack_public_path__ + "static/media/visite-local.5ec7cf33.png";